import { clearPlatformAccessSessionMarkers } from '../lib/platformAccessEvents';

const CACHE_KEY = 'communityAccessCache';
const CACHE_DURATION_MS = 10 * 60 * 1000; // 10 minutes

const safeWindow = () => (typeof window !== 'undefined' ? window : null);
const safeStorage = () => {
  const win = safeWindow();
  return win ? win.localStorage : null;
};

export const getCachedCommunityAccess = () => {
  const storage = safeStorage();
  if (!storage) return null;

  try {
    const raw = storage.getItem(CACHE_KEY);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw);
    if (!parsed?.expiresAt || parsed.expiresAt < Date.now()) {
      storage.removeItem(CACHE_KEY);
      return null;
    }

    return parsed;
  } catch (error) {
    console.error('Failed to read community access cache', error);
    storage.removeItem(CACHE_KEY);
    return null;
  }
};

export const setCachedCommunityAccess = ({ communityName, managerName, userId }) => {
  const storage = safeStorage();
  if (!storage) return;

  const payload = {
    communityName,
    managerName,
    userId,
    expiresAt: Date.now() + CACHE_DURATION_MS,
  };

  storage.setItem(CACHE_KEY, JSON.stringify(payload));
};

export const clearCachedCommunityAccess = () => {
  const storage = safeStorage();
  if (!storage) return;

  storage.removeItem(CACHE_KEY);
};

export const persistCommunityContext = ({ communityName, managerName, userId }) => {
  const normalizedCommunityName = communityName || 'Community';
  const normalizedManagerName = managerName || 'Manager';

  const storage = safeStorage();
  if (!storage) return;

  storage.setItem('communityName', normalizedCommunityName);
  storage.setItem('managerName', normalizedManagerName);

  setCachedCommunityAccess({
    communityName: normalizedCommunityName,
    managerName: normalizedManagerName,
    userId,
  });
};

export const clearCommunityContext = () => {
  const storage = safeStorage();
  if (!storage) return;

  const cachedUserId = getCachedCommunityAccess()?.userId ?? null;
  storage.removeItem('communityName');
  storage.removeItem('managerName');
  clearCachedCommunityAccess();
  clearPlatformAccessSessionMarkers('community', cachedUserId);
};

